export * from "./services/localization.service";
export * from "./localization.module";
//# sourceMappingURL=index.js.map